'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _event = require('../helpers/event');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDetail = function EventDetail(props) {
  var backButtonAction = props.backButtonAction,
      event = props.event,
      mapApiKey = props.mapApiKey,
      selectedDateProp = props.selectedDate,
      typeAction = props.typeAction,
      tagAction = props.tagAction,
      audienceAction = props.audienceAction;

  var priceProps = {
    type: event.price_type,
    notes: event.price_notes,
    prices: event.prices
  };
  var contactProps = {
    name: event.contact_name,
    email: event.contact_email,
    phone: event.contact_phone,
    url: event.contact_url
  };
  var mapProps = {
    latitude: event.venue.latitude,
    longitude: event.venue.longitude,
    apiKey: mapApiKey
  };

  var selectedDateString = selectedDateProp || (0, _moment2.default)(event.dates[0].start_date).format('YYYY-MM-DD_HH-mm-ss');
  var selectedDate = event.dates.find(function (date) {
    return (0, _moment2.default)(date.start_date).format('YYYY-MM-DD_HH-mm-ss') === selectedDateString;
  });
  var subtitle = _react2.default.createElement(_.SelectionList, { available: event.types, labelKey: 'name', layout: 'commaSeparated', appearance: 'plain', action: typeAction });

  return _react2.default.createElement(
    _.Page,
    { title: event.title, subtitle: subtitle, backButtonAction: backButtonAction, className: 'EventDetail', layout: 'custom' },
    _react2.default.createElement(
      'div',
      { className: 'basicsWrapper' },
      _react2.default.createElement(
        'section',
        { className: 'basics' },
        _react2.default.createElement(_.EventDate, { dates: event.dates, selectedDate: selectedDate, pathName: '/evenements/' + event.slug + '/' + event.id }),
        _react2.default.createElement(_.EventVenue, { venue: event.venue }),
        _react2.default.createElement(_.StaticMap, mapProps)
      )
    ),
    _react2.default.createElement(
      'section',
      { className: 'details' },
      _react2.default.createElement(
        'div',
        { className: 'description' },
        _react2.default.createElement(_.EventImage, { src: event.photo_url }),
        _react2.default.createElement(_.EventDescription, { description: event.description }),
        _react2.default.createElement(
          'div',
          { className: 'extras' },
          event.tags.length > 0 && _react2.default.createElement(
            _.HeadingBlock,
            { title: (0, _i18n2.default)('tags'), className: 'tags', inline: true },
            _react2.default.createElement(_.SelectionList, { available: event.tags, labelKey: 'name', layout: 'inline', appearance: 'tag', action: tagAction })
          ),
          _react2.default.createElement(
            _.HeadingBlock,
            { title: (0, _i18n2.default)('share'), className: 'share', inline: true },
            _react2.default.createElement(_.ShareLinks, { event: event, icons: ['twitter', 'facebook'] })
          ),
          _react2.default.createElement(
            _.HeadingBlock,
            { title: (0, _i18n2.default)('save'), className: 'save', inline: true },
            _react2.default.createElement(_.ShareLinks, { event: event, icons: ['google', 'ical', 'print'] })
          )
        ),
        event.video && _react2.default.createElement(_.EventVideo, { html: event.video.html })
      ),
      _react2.default.createElement(
        'aside',
        null,
        _react2.default.createElement(_.EventImage, { src: event.photo_url }),
        event.ticket_url && _react2.default.createElement(_.Button, { href: event.ticket_url, title: (0, _i18n2.default)('tickets'), type: 'primary', width: 'full', newWindow: true }),
        (0, _event.hasPrice)(event) && _react2.default.createElement(
          _.HeadingBlock,
          { title: (0, _i18n2.default)('price'), className: 'price' },
          _react2.default.createElement(_.EventPrice, priceProps)
        ),
        (0, _event.hasContact)(event) && _react2.default.createElement(
          _.HeadingBlock,
          { title: (0, _i18n2.default)('contact'), className: 'contact' },
          _react2.default.createElement(_.EventContact, contactProps)
        ),
        event.audiences.length > 0 && _react2.default.createElement(
          _.HeadingBlock,
          { title: (0, _i18n2.default)('audiences'), className: 'audiences' },
          _react2.default.createElement(_.SelectionList, { available: event.audiences, labelKey: 'name', appearance: 'plain', action: audienceAction })
        )
      )
    )
  );
};

EventDetail.propTypes = {
  /**
   * Action triggered when the Back button is clicked
   */
  backButtonAction: _propTypes2.default.func,
  /**
   * Event object in the Caligram API format.
   */
  event: _propTypes2.default.object.isRequired,
  /**
   * The Google Static Maps API key.
   */
  mapApiKey: _propTypes2.default.string.isRequired,
  /**
   * The selected date as used in the query string.
   */
  selectedDate: _propTypes2.default.string,
  /**
   * Function called when a type is clicked.
   */
  typeAction: _propTypes2.default.func,
  /**
   * Function called when a tag is clicked.
   */
  tagAction: _propTypes2.default.func,
  /**
   * Function called when an audience is clicked.
   */
  audienceAction: _propTypes2.default.func
};

EventDetail.defaultProps = {
  backButtonAction: function backButtonAction() {},
  typeAction: function typeAction() {},
  tagAction: function tagAction() {},
  audienceAction: function audienceAction() {}
};

exports.default = EventDetail;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDetail.js
// module id = 268
// module chunks = 0